import React, { useContext, useEffect, useState } from 'react';
import get from 'lodash/get';
import HOME_PAGE_CONTAINER_CONSTANTS from 'components/homePageContainer/Constants/AU/homePageContainerConstants';
import { getContentCall } from '@kfc-global/react-shared/redux/Actions/ContentAction';
import { syncContentData } from '@kfc-global/react-shared/redux/Actions/SyncContentAction';
import { useDispatch, useSelector } from 'react-redux';
import {
  getAndCheck,
  getBrandData,
  getDownloadData,
  getHeaderContentData,
  getValueOrDefaultArray,
  getValueOrDefaultObject,
  getValueOrnull,
  isEmptyObject,
  isSupportedTenantCode,
} from 'common/utilities/utils';
import GiftCardHomePageComponent from 'organisms/GiftCard/Presentation/GiftCardHomePageComponent';
import { UserOrderContext } from 'context/context';
import { getCmsClient } from 'common/utilities/cmsClient';
import { HOME_PAGE, ROUTE_URL } from 'common/constants/SharedConstants';
import { CommunicationComponent } from 'organisms/Communication';
import { RegionalMarketingComponent } from 'organisms/MarketingHero/AU';
import { SingleBannerComponent } from 'organisms/MarketingHero/AU/Presentation/SingleBannerComponent';
import { GenericMenuCategories } from 'organisms/GenericMenuCategories';
import { OffersAndPromotionsContainer } from 'organisms/OffersAndPromotions/OffersAndPromotions';
import { LoyaltyCrmContainer } from 'organisms/LoyaltyCrmSignupComponent';
import { StructureData } from 'organisms/StructureDataComponent';
import RecommendedContainer from 'organisms/RecommendedComponent/AU/Container/RecommendedContainer';
import { ClearCartModule } from 'organisms/ClearCartModule/Container/ClearCartComponent';
import { ChannelManager } from 'common/manager';
import { showCustomizationModalAction } from '@kfc-global/react-shared/redux/Actions/CartAction';
import PastOrderComponent from 'organisms/PastOrderComponentGlobal/Container/PastOrderContainer';
import BrandComponentContainer from 'organisms/BrandComponent/Container/BrandComponentContainer';
import DownloadKfcContainer from 'organisms/DownloadKfc/Container/DownloadKfcContainer';
import START_ORDER_CONSTANTS from 'organisms/StartOrderComponent/Constants/startOrderConstants';
import DISPOSITION_CONSTANTS from 'organisms/DispositionModule/Constants/DispositionConstants';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { RECOMMENDED_CONSTANTS } from 'organisms/RecommendedComponent/AU/Constants/RecommendedComponentConstant';
import { MENU_PDP_PAGE_CONSTANTS } from 'organisms/MenuPDPPage/AU/Constants/MenuPDPPageConstants';
import { ExposedDispositionComponent } from 'organisms/SelectContentDisposition/AU/Presentation/ExposedDispositionComponent';
import BrowseMenu from 'organisms/BrowseMenu/Container/BrowseMenuContainer';
import LtoBannerComponent from 'organisms/LtoBanner/Presentation/LtoBannerComponent';
import PromosRewardsContainer from 'organisms/PromosRewards/Container/PromosRewardsContainer';
import { getCustomerInfo } from '@kfc-global/react-shared/redux/Actions/OrderservAction';

// context to hold user order state
// export const UserOrderContext = React.createContext();
/**
 * Main Container for Entire container Components
 */
const HomePageContainer = props => {
  const { CROSSELL } = MENU_PDP_PAGE_CONSTANTS;
  const { RECOMMENDED_HEADER_TITLE } = RECOMMENDED_CONSTANTS;
  const {
    DISPOSITION,
    BROWSER_CATEGORIES,
    OFFERS_DEALS,
    CAROUSAL,
    ORDERSERV,
    ROUTING,
    CRM,
    WELCOME_MESSAGE,
    RECOMMENDATION,
    LTO_BANNER,
    BRAND,
    DOWNLOADAPP,
    PROMOS_REWARDS,
    SIINGLE_BANNER,
    GIFT_CARD,
  } = HOME_PAGE_CONTAINER_CONSTANTS;

  const dispatch = useDispatch();
  const { location, history } = props;
  const { userOrderState, userOrderStateDispatch } = useContext(UserOrderContext);

  let userParams = useSelector(data => data.appStateReducer.userStatus);
  // defines user's current state
  let segmentedHomePageData = null,
    genericMenuData = null,
    homeContentfulOrderResp = null;

  const [recommendedProds, setRecommendedProds] = useState([]);
  const cartReducer = useSelector(data => data.cartReducer);
  const tenantReducer = useSelector(data => data.tenantReducer);
  const authReducer = useSelector(data => data.authReducer);
  const { showProductListingModal = false } = getValueOrDefaultObject(cartReducer);

  /**
   * method to setup content data for home page config
   */
  const allContentData = useSelector(data => {
    return {
      homePageContent: get(data, 'contentReducer.response', null),
      orderServePageContent: get(data, 'orderServReducer.offerAndDeals', null),
      pastOrdersData: get(data, 'profileReducer.pastOrders', null),
      basicData: get(data, 'profileReducer.basic', null),
      favouriteOrders: get(data, 'profileReducer.favouriteOrders', null),
      tenantReducerContent: get(data, 'tenantReducer', null),
      appStateReducerContent: get(data, 'appStateReducer', null),
      cartReducerContent: get(data, 'cartReducer', null),
      recommendedProducts: get(data, 'profileReducer.recommendedProducts', null),
    };
  });

  const refreshOffers = () => {
    // eslint-disable-next-line no-empty
  };

  useEffect(() => {
    if (userParams?.loggedIn && !authReducer?.isLoading) {
      const reqPayload = {
        updateUserData: true,
      };
      dispatch(getCustomerInfo(reqPayload));
    }
  }, [userParams?.loggedIn, authReducer?.isLoading, dispatch]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const {
      DISPOSITION_ACTION: { SET_QR_DEEPLINK_MODE },
    } = DISPOSITION_CONSTANTS;
    if (history?.location?.pathname?.includes('qrhome')) {
      const locationSearch = history?.location?.search;
      const queryName = new URLSearchParams(locationSearch);
      const deeplinkRestuarandStoreId = queryName.get('restaurantid');
      const { DISPOSITION_DATA } = START_ORDER_CONSTANTS;
      userOrderStateDispatch({
        type: SET_QR_DEEPLINK_MODE,
        value: { deepLinkStoreMode: true, deeplinkSelectedStoreId: deeplinkRestuarandStoreId },
      });
      userOrderStateDispatch({ type: DISPOSITION_DATA, value: { showDisposition: true } });
    }
  }, [history, userOrderStateDispatch]);

  /**
   * Call to get content full data for home and marketing compoent
   */
  useEffect(() => {
    dispatch(
      syncContentData({
        object: getCmsClient(),
        syncObj: { initial: true },
      }),
    );
  }, [dispatch, tenantReducer?.country, userOrderState.cmsInitialized]);

  useEffect(() => {
    console.log('userOrderState.cmsInitialized', userOrderState.cmsInitialized);
    dispatch(
      getContentCall({
        object: getCmsClient(),
        contentFull: {
          content_type: 'landingPage',
          'fields.channel': ChannelManager.channel,
          include: '5',
        },
        userParams,
      }),
    );
  }, [dispatch, userParams, userOrderState.cmsInitialized]);

  useEffect(() => {
    if (showProductListingModal) {
      dispatch(
        showCustomizationModalAction({
          showProductListingModal: false,
          categorySelected: '',
        }),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  // when both the data is avaible call the util functions
  if (allContentData.homePageContent && allContentData.tenantReducerContent && allContentData.appStateReducerContent) {
    segmentedHomePageData = getValueOrnull(getHeaderContentData(allContentData.homePageContent));
    genericMenuData = getValueOrDefaultObject(allContentData.orderServePageContent);
    homeContentfulOrderResp = getValueOrDefaultArray(allContentData?.homePageContent?.homeContentfulResp);
  }
  const RegionalMarketingContainer =
    (segmentedHomePageData?.[CAROUSAL] && (
      <RegionalMarketingComponent
        contentData={segmentedHomePageData?.[CAROUSAL] ?? {}}
        location={location}
        history={history}
        userParams={userParams}
      />
    )) ||
    null;

  const SingleMarketingContainer =
    (segmentedHomePageData?.[SIINGLE_BANNER] && (
      <SingleBannerComponent
        contentData={segmentedHomePageData?.[SIINGLE_BANNER] ?? {}}
        location={location}
        history={history}
        userParams={userParams}
      />
    )) ||
    null;

  let ReorderContainer = (
    <PastOrderComponent
      pastOrders={allContentData.pastOrdersData}
      basic={allContentData.basicData}
      favouriteOrders={allContentData.favouriteOrders}
      tenantReducerData={allContentData.tenantReducerContent}
      isLoggedIn={userParams.loggedIn}
    />
  );

  const GenericMenuCategoriesContainer = () =>
    isSupportedTenantCode() ? (
      <BrowseMenu tenantReducer={tenantReducer} dispositionType={cartReducer?.cartData?.service} />
    ) : (
      <GenericMenuCategories contentData={genericMenuData} />
    );

  const OffersAndPromotionsCompContainer = (
    <OffersAndPromotionsContainer history={history} refreshOffers={refreshOffers} />
  );

  const CommunicationContainer =
    (isEmptyObject(segmentedHomePageData) && segmentedHomePageData[ROUTING] && (
      <CommunicationComponent contentData={getValueOrDefaultObject(segmentedHomePageData[ROUTING])} />
    )) ||
    null;
  const LoyaltyCrmCompContainer =
    (isEmptyObject(segmentedHomePageData) && segmentedHomePageData[CRM] && (
      <LoyaltyCrmContainer contentData={getValueOrDefaultObject(segmentedHomePageData[CRM])} />
    )) ||
    null;

  const LTOBannerContainer =
    (isEmptyObject(segmentedHomePageData) && segmentedHomePageData[LTO_BANNER] && (
      <LtoBannerComponent contentData={getValueOrDefaultObject(segmentedHomePageData[LTO_BANNER])} history={history} />
    )) ||
    null;

  const giftCardComponent =
    (segmentedHomePageData && segmentedHomePageData[GIFT_CARD] && (
      <GiftCardHomePageComponent contentData={segmentedHomePageData[GIFT_CARD]} history={history} />
    )) ||
    null;

  const brandPageComponent = data => {
    const brandData = getBrandData(data);
    return <BrandComponentContainer brandData={brandData} />;
  };

  const downloadKFComponent = () => {
    const data = homeContentfulOrderResp.filter(item => item?.sys?.contentType?.sys?.id === DOWNLOADAPP);
    const downloadData = getDownloadData(data);
    return <DownloadKfcContainer downloadData={downloadData} />;
  };

  const promosRewards =
    (isEmptyObject(segmentedHomePageData) && segmentedHomePageData[PROMOS_REWARDS] && (
      <PromosRewardsContainer
        contentData={getValueOrDefaultObject(segmentedHomePageData[PROMOS_REWARDS])}
        history={history}
      />
    )) ||
    null;

  const recommendationsList = allContentData.recommendedProducts;
  useEffect(() => {
    if (recommendationsList?.length) {
      setRecommendedProds(recommendationsList);
    }
  }, [recommendationsList]);

  const RecommendedCompContainer = getAndCheck(Boolean(recommendedProds.length), userParams.loggedIn) && (
    <RecommendedContainer
      products={recommendedProds}
      country={tenantReducer?.country}
      header={RECOMMENDED_HEADER_TITLE}
      recommendedRule={CROSSELL}
    />
  );

  const showWelcomeBanner =
    (allContentData?.pastOrdersData?.length > 0 || allContentData?.favouriteOrders?.length > 0) && userParams?.loggedIn;

  const skipContent = (
    <a data-ajax='false' className='skiptocontent' href='#startorder-container'>
      Skip to main content
    </a>
  );
  const [seoData, setSeoData] = useState({ page: '', seoObj: {} });

  useEffect(() => {
    const timer = setTimeout(() => {
      /* istanbul ignore next */
      if (window.location.pathname === ROUTE_URL.HOME_PAGE) {
        setSeoData({ page: HOME_PAGE, seoObj: {} });
      }
      clearTimeout(timer);
    }, 100);

    return () => {
      clearTimeout(timer);
    };
  }, [allContentData?.homePageContent, location, history]);

  return (
    <React.Fragment>
      {getAndCheck(!isSupportedTenantCode(), skipContent)}
      <StructureData {...seoData} />
      <div role='main'>
        <h1 className='sr-only'>{translateWithI18Next(START_ORDER_CONSTANTS.HIDDEN_TEXT)}</h1>
        <ExposedDispositionComponent
          contentDispositionData={segmentedHomePageData?.[DISPOSITION]}
          userParams={userParams}
        />
        {homeContentfulOrderResp?.map(item => {
          const name = item?.fields?.name ?? '';
          const id = item?.sys?.contentType?.sys?.id ?? '';
          let renderContainer;
          if (id === CAROUSAL) {
            renderContainer = !showWelcomeBanner ? RegionalMarketingContainer : null;
          } else if (id === ORDERSERV) {
            if (name === WELCOME_MESSAGE && showWelcomeBanner) {
              renderContainer = ReorderContainer;
            } else if (name === BROWSER_CATEGORIES) {
              renderContainer = GenericMenuCategoriesContainer();
            } else if (name === RECOMMENDATION) {
              renderContainer = RecommendedCompContainer;
            } else if (name === OFFERS_DEALS) {
              renderContainer = OffersAndPromotionsCompContainer;
            }
          } else if (id === PROMOS_REWARDS) {
            renderContainer = promosRewards;
          } else if (id === ROUTING) {
            renderContainer = CommunicationContainer;
          } else if (id === CRM) {
            renderContainer = LoyaltyCrmCompContainer;
          } else if (id === LTO_BANNER) {
            renderContainer = LTOBannerContainer;
          } else if (id === GIFT_CARD) {
            renderContainer = giftCardComponent;
          } else if (id === BRAND) {
            renderContainer = brandPageComponent(item);
          } else if (id === DOWNLOADAPP) {
            renderContainer = downloadKFComponent();
          } else if (id === SIINGLE_BANNER && allContentData?.pastOrdersData?.length === 0) {
            renderContainer = SingleMarketingContainer;
          } else {
            renderContainer = null;
          }
          return <div key={item.sys?.id ?? ''}>{renderContainer}</div>;
        })}
      </div>
      {userOrderState.showCartClearAlert ? <ClearCartModule /> : null}
    </React.Fragment>
  );
};

export default HomePageContainer;
